import { useState, useEffect } from "react";
import Header from "./Header";

export default function App() {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
    cpf_cnpj: "",
    razao_social: "",
    cep: "",
    endereco: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    uf: "",
    modelo_equipamento: "",
    num_serie: "",
    defeito: "",
    garantia: ""
  });

  const [status, setStatus] = useState("");

  function formatCpfCnpj(value) {
    const digits = value.replace(/\D/g, "");
    if (digits.length === 11) {
      return digits
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{2})$/, "$1-$2");
    } else if (digits.length === 14) {
      return digits
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1/$2")
        .replace(/(\d{4})(\d{2})$/, "$1-$2");
    } else {
      return "";
    }
  }

  useEffect(() => {
    const cep = formData.cep.replace(/\D/g, "");
    if (cep.length === 8) {
      fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then(res => res.json())
        .then(data => {
          if (!data.erro) {
            setFormData(prev => ({
              ...prev,
              endereco: data.logradouro || "",
              bairro: data.bairro || "",
              cidade: data.localidade || "",
              uf: data.uf || ""
            }));
          }
        });
    }
  }, [formData.cep]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Enviando...");
    try {
      const res = await fetch("/api/chamados", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
        setStatus(`✅ Chamado enviado com sucesso!`);
        setFormData({
          nome: "",
          email: "",
          telefone: "",
          cpf_cnpj: "",
          razao_social: "",
          cep: "",
          endereco: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade: "",
          uf: "",
          modelo_equipamento: "",
          num_serie: "",
          defeito: "",
          garantia: ""
        });
      } else {
        setStatus(`❌ Erro: ${data.erro || "Falha ao enviar o chamado."}`);
      }
    } catch (err) {
      setStatus("❌ Erro de comunicação com o servidor.");
    }
  };

  return (
    <div className="min-h-screen bg-teal-700 pt-20">
      <Header />

      <div classname="flex items-center justify-center p-4 w-full">
       <div className="bg-white p-8 rounded-lg shadow-md max-w-4xl w-full mx-auto">
         <h1 className="text-2xl font-semibold text-teal-700 mb-6">ABRA UM CHAMADO</h1>
         <p className="text-sm text-gray-600 mb-6">* Campos obrigatórios</p>
         <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
           <input name="nome" required placeholder="Nome do responsável*" className="border p-2 rounded" value={formData.nome} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Por favor, informe o nome.")} onInput={e => e.target.setCustomValidity("")} />
           <input name="email" type="email" required placeholder="E-mail*" className="border p-2 rounded" value={formData.email} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Por favor, informe um e-mail válido.")} onInput={e => e.target.setCustomValidity("")} />
           <input name="cpf_cnpj" required placeholder="CPF ou CNPJ*" className="border p-2 rounded" value={formData.cpf_cnpj} onChange={handleChange} onBlur={(e) => { const formatted = formatCpfCnpj(e.target.value); setFormData({ ...formData, cpf_cnpj: formatted }); }} onInvalid={e => e.target.setCustomValidity("Informe um CPF ou CNPJ válido (somente números).")} onInput={e => e.target.setCustomValidity("")} />
           <input name="razao_social" required placeholder="Razão Social*" className="border p-2 rounded" value={formData.razao_social} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Por favor, informe a razão social.")} onInput={e => e.target.setCustomValidity("")} />
           <input name="telefone" required placeholder="Telefone (DDD+Número)*" className="border p-2 rounded" value={formData.telefone} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Informe o telefone com DDD.")} onInput={e => e.target.setCustomValidity("")} />
           <input name="cep" required placeholder="CEP*" className="border p-2 rounded" value={formData.cep} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Informe o CEP.")} onInput={e => e.target.setCustomValidity("")} />
           <input name="endereco" required placeholder="Endereço*" className="border p-2 rounded" value={formData.endereco} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Informe o endereço.")} onInput={e => e.target.setCustomValidity("")} />
           <input name="numero" required placeholder="Número*" className="border p-2 rounded" value={formData.numero} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Informe o número do endereço.")} onInput={e => e.target.setCustomValidity("")} />
           <input name="complemento" placeholder="Complemento" className="border p-2 rounded" value={formData.complemento} onChange={handleChange} />
           <input name="bairro" required placeholder="Bairro*" className="border p-2 rounded" value={formData.bairro} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Informe o bairro.")} onInput={e => e.target.setCustomValidity("")} />
           <input name="cidade" required placeholder="Cidade*" className="border p-2 rounded" value={formData.cidade} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Informe a cidade.")} onInput={e => e.target.setCustomValidity("")} />
           <select name="uf" required className="border p-2 rounded text-gray-700" value={formData.uf} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Selecione o estado.")} onInput={e => e.target.setCustomValidity("")}>
             <option value="">Estado*</option>
             {["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"].map(uf => (
               <option key={uf} value={uf}>{uf}</option>
             ))}
           </select>
           <input name="modelo_equipamento" required placeholder="Modelo do Equipamento*" className="border p-2 rounded" value={formData.modelo_equipamento} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Informe o modelo do equipamento.")} onInput={e => e.target.setCustomValidity("")} />
           <input name="num_serie" required placeholder="Nº de Série*" className="border p-2 rounded" value={formData.num_serie} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Informe o número de série.")} onInput={e => e.target.setCustomValidity("")} />
           <textarea name="defeito" required placeholder="Descrição do Problema*" className="border p-2 rounded col-span-2" rows="4" value={formData.defeito} onChange={handleChange} onInvalid={e => e.target.setCustomValidity("Descreva o problema.")} onInput={e => e.target.setCustomValidity("")} />
           <div className="col-span-2">
             <label className="block text-sm text-gray-700 mb-2">Equipamento em garantia ou sob contrato?</label>
             <div className="flex gap-4">
               <label className="flex items-center gap-2">
                 <input type="radio" name="garantia" value="Sim" checked={formData.garantia === "Sim"} onChange={handleChange} /> Sim
               </label>
               <label className="flex items-center gap-2">
                 <input type="radio" name="garantia" value="Não" checked={formData.garantia === "Não"} onChange={handleChange} /> Não
               </label>
             </div>
           </div>
           <div className="col-span-2 text-sm text-gray-600">
             Ao informar meus dados, eu concordo com a <a href="#" className="text-blue-600 underline">Política de Privacidade</a>.
           </div>
           <div className="col-span-2">
             <button type="submit" className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded font-semibold">ENVIAR</button>
           </div>
           {status && <p className="col-span-2 mt-4 text-sm text-gray-700">{status}</p>}
         </form>
       </div>
      </div>
    </div>
  );
}
